import { render, staticRenderFns } from "./PermissionRow.vue?vue&type=template&id=00d0b16a&scoped=true&"
import script from "./PermissionRow.vue?vue&type=script&lang=js&"
export * from "./PermissionRow.vue?vue&type=script&lang=js&"
import style0 from "./PermissionRow.vue?vue&type=style&index=0&id=00d0b16a&prod&lang=scss&scoped=true&"
import style1 from "./PermissionRow.vue?vue&type=style&index=1&id=00d0b16a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d0b16a",
  null
  
)

export default component.exports